export interface HtmlRenderProps {
	unsafeHtml: string;
}

const HtmlRender = ({ unsafeHtml }: HtmlRenderProps) => {
	const sanitizeHtml = (html: string) => {
		const doc = new DOMParser();

		return {
			__html: doc.parseFromString(html, "text/html").body.innerHTML,
		};
	};

	return <div dangerouslySetInnerHTML={sanitizeHtml(unsafeHtml)} />;
};

export default HtmlRender;
